import React from "react";
import {roleService} from "../jwt/_services";

export const roleProvider = {
    getOptions,
    getItem,
};

async function getOptions(){
    try {
        const listItems = await roleService.getAll();

        return listItems.map((itemData) => {
            const { id, authority } = itemData
            return (
                {
                    id: id,
                    value: authority,
                    label: <div><label>{authority}</label></div>
                }
            )
        });
    } catch (error) {
       console.log(error.message)
    }
}

async function getItem(id){
    try {
        const item = await roleService.getItem(id);
        return (
            {
                id: item.id,
                value: item.authority,
                label: <div><label>{item.authority}</label></div>}
        );
    } catch (error) {
        console.log(error.message)
    }
}